import { useCampaignStore, selectSelectedCampaign } from '@/stores/campaignStore';
import { DemoSeedCard, DemoImportCard, FinanceResetCard } from '@/components/campaign';
import { SettingsScopeSection } from './SettingsScopeSection';

/**
 * The "Demo controls" scope band on the Settings hub (ADR-056). Shown on any
 * campaign flagged `isDemo`, to ALL its members — gated on the campaign flag, not
 * on platform-admin — so a salesperson who is an ordinary member can run demo
 * tooling. Hidden entirely on a real (non-demo) campaign.
 *
 * The demo beats run top to bottom: seed the baseline ledger, simulate the import that
 * flags, then reset back to pristine between runs.
 */
export function DemoControlsSection() {
  const campaign = useCampaignStore(selectSelectedCampaign);

  if (!campaign?.isDemo) return null;

  return (
    <SettingsScopeSection title="Demo controls" description="Disposable demo data — safe to reset">
      <div className="space-y-4">
        <DemoSeedCard />
        <DemoImportCard />
        <FinanceResetCard />
      </div>
    </SettingsScopeSection>
  );
}
